import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            supplierData: [],
        }
    },

    computed: {
        ...mapGetters(['selectedContainer']),

        suppliers() {
            return this.supplierData.map(item => {
                const res = {
                    'SupplierID': item.SupplierID,
                    'SupplierName': item.SupplierName
                }
                return res
            })
        },
    },

    methods: {
        async fetchSuppliers(container) {
            container = container || this.selectedContainer
            let { data } = await this.$http.get(
                `Container/${container.ContainerID}/Supplier`
            )
            data.sort((a, b) => {
                if (a && b && a.SupplierName && b.SupplierName) {
                    return a.SupplierName.localeCompare(
                        b.SupplierName,
                        'en',
                        { numeric: true }
                    )
                }
            })
            this.supplierData = data
            return data
        },
    },
}
